import React from 'react';

const Features = () => {
  const features = [
    {
      title: 'Real-Time Data Intelligence',
      description: 'Access live startup metrics, funding rounds, and market data from global sources. Make decisions with the most current information available.',
      icon: '📊',
      color: 'linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)'
    },
    {
      title: 'AI-Powered Due Diligence',
      description: 'Automate comprehensive startup analysis with our advanced AI engine. Reduce due diligence time from weeks to hours.',
      icon: '🤖',
      color: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)'
    },
    {
      title: 'Global Market Coverage',
      description: 'Track startups and venture activity across all major markets worldwide. Get insights into emerging ecosystems and opportunities.',
      icon: '🌍',
      color: 'linear-gradient(135deg, #10b981 0%, #059669 100%)'
    },
    {
      title: 'Risk Assessment Engine',
      description: 'Quantify startup risk with multi-dimensional analysis. Identify red flags and opportunities with confidence scoring.',
      icon: '🛡️',
      color: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)'
    },
    {
      title: 'Performance Analytics',
      description: 'Benchmark portfolio performance against market standards. Track IRR, TVPI, and other key metrics in real-time.',
      icon: '⚡',
      color: 'linear-gradient(135deg, #eab308 0%, #f59e0b 100%)'
    },
    {
      title: 'Portfolio Monitoring',
      description: 'Continuous monitoring of portfolio companies with automated alerts for critical events and performance changes.',
      icon: '👁️',
      color: 'linear-gradient(135deg, #6366f1 0%, #3b82f6 100%)'
    }
  ];

  return (
    <div id="features" className="features-section">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <h2 className="section-title">
            Revolutionizing Venture Capital
          </h2>
          <p className="section-subtitle">
            VentureOS brings institutional-grade data and analytics to every venture capital decision, 
            transforming how investors discover, evaluate, and manage opportunities.
          </p>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon" style={{background: feature.color}}>
                {feature.icon}
              </div>
              
              <h3 className="feature-title">
                {feature.title}
              </h3>
              
              <p className="feature-description">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="cta-section">
          <h3 className="cta-title">
            Ready to Transform Your Investment Process?
          </h3>
          <p className="cta-subtitle">
            Join leading VCs who are already using data-driven insights to make better investment decisions.
          </p>
          <div className="cta-features">
            <span>✓ Bloomberg-level data quality</span>
            <span>✓ AI-powered insights</span>
            <span>✓ Global market coverage</span>
            <span>✓ Real-time monitoring</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
